import { formatDateTimeWithTimezone } from './format-date';

export function formatSaleDate(startDate, endDate, options = {}) {
  const {
    now = new Date(),
    timezone,
    locale,
    showTimezone = false,
    startText = 'Starts on',
    startedText = 'Started on',
    endText = 'Ends on',
    endedText = 'Ended on',
    showStartedOn = true,
    showBothMessages = false,
  } = options;

  const start = startDate ? new Date(startDate) : null;
  const end = endDate ? new Date(endDate) : null;

  const formatDate = date =>
    formatDateTimeWithTimezone(date, {
      timeZone: timezone,
      locale,
      showTimezone,
    });

  if (showBothMessages) {
    // Dashboard mode: show both messages when possible
    const messages = [];

    // Add start message
    if (start) {
      if (start > now) {
        messages.push(`${startText} ${formatDate(start)}`);
      } else if (showStartedOn) {
        messages.push(`${startedText} ${formatDate(start)}`);
      }
    }

    // Add end message
    if (end) {
      if (end < now) {
        messages.push(`${endedText} ${formatDate(end)}`);
      } else {
        messages.push(`${endText} ${formatDate(end)}`);
      }
    }

    return messages.length > 0 ? messages : null;
  } else {
    // Checkout mode: show only one message (original logic)

    // Handle start date
    if (start) {
      if (start > now) {
        return `${startText} ${formatDate(start)}`;
      }
      if (start <= now && !end && showStartedOn) {
        return `${startedText} ${formatDate(start)}`;
      }
    }

    // Handle end date
    if (end) {
      if (end < now) {
        return `${endedText} ${formatDate(end)}`;
      }
      if (end >= now) {
        return `${endText} ${formatDate(end)}`;
      }
    }

    return null;
  }
}
